import React from "react";
import { IconT } from "types/utils";
import { theme } from "styles/themes";

const VerifiedCheckIcon = ({
  height = "16",
  width = "16",
  stroke = theme.colors["picton-blue"],
  fill = theme.colors.white,
}: IconT) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_287_320)">
        <path
          d="M6.00004 7.99998L7.33337 9.33331L10.3334 6.33331M4.88922 2.54578C5.42511 2.50301 5.93385 2.29228 6.34302 1.94359C7.29786 1.12989 8.70222 1.12989 9.65706 1.94359C10.0662 2.29228 10.575 2.50301 11.1109 2.54578C12.3614 2.64557 13.3545 3.63861 13.4542 4.88916C13.497 5.42505 13.7077 5.93379 14.0564 6.34296C14.8701 7.2978 14.8701 8.70216 14.0564 9.657C13.7077 10.0662 13.497 10.5749 13.4542 11.1108C13.3545 12.3614 12.3614 13.3544 11.1109 13.4542C10.575 13.4969 10.0662 13.7077 9.65706 14.0564C8.70222 14.8701 7.29786 14.8701 6.34302 14.0564C5.93385 13.7077 5.42511 13.4969 4.88922 13.4542C3.63867 13.3544 2.64563 12.3614 2.54584 11.1108C2.50307 10.5749 2.29235 10.0662 1.94365 9.657C1.12995 8.70216 1.12995 7.2978 1.94365 6.34296C2.29235 5.93379 2.50307 5.42505 2.54584 4.88916C2.64563 3.63861 3.63867 2.64557 4.88922 2.54578Z"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_287_320">
          <rect width="16" height="16" fill={fill} />
        </clipPath>
      </defs>
    </svg>
  );
};
export default VerifiedCheckIcon;
